import { c as _c } from "react/compiler-runtime";
import { RepSearchState } from "./UserPageRepNewRepSearch";
export default function UserPageRepNewRepSearchDropdown(t0) {
  const $ = _c(17);
  const {
    categories,
    onRepSelect,
    state,
    minSearchLength,
    maxSearchLength
  } = t0;
  let t1;
  if ($[0] !== minSearchLength || $[1] !== state) {
    t1 = state === RepSearchState.MIN_LENGTH_ERROR && <li className="tw-group tw-justify-between tw-w-full tw-flex tw-rounded-lg tw-relative  tw-select-none tw-p-2 tw-text-iron-200 tw-font-normal tw-text-sm">Type at least {minSearchLength} characters</li>;
    $[0] = minSearchLength;
    $[1] = state;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== maxSearchLength || $[4] !== state) {
    t2 = state === RepSearchState.MAX_LENGTH_ERROR && <li className="tw-group tw-justify-between tw-w-full tw-flex tw-rounded-lg tw-relative  tw-select-none tw-p-2 tw-text-iron-200 tw-font-normal tw-text-sm">Type at most {maxSearchLength} characters</li>;
    $[3] = maxSearchLength;
    $[4] = state;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== state) {
    t3 = state === RepSearchState.LOADING && <li className="tw-group tw-text-iron-200 tw-text-sm tw-font-normal tw-justify-between tw-w-full tw-flex tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-p-2 hover:tw-bg-iron-700 tw-transition tw-duration-300 tw-ease-out">Loading...</li>;
    $[6] = state;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== categories || $[9] !== onRepSelect || $[10] !== state) {
    t4 = state === RepSearchState.HAVE_RESULTS && categories.map(category => <li key={category} className="tw-group tw-text-white tw-justify-between tw-w-full tw-flex tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-px-2 tw-py-1 hover:tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out"><button onClick={e => {
        e.stopPropagation();
        onRepSelect(category);
      }} className="tw-bg-transparent tw-border-none tw-w-full tw-h-full tw-text-left"><span className="tw-inline-block tw-text-sm tw-font-medium tw-text-white">{category}</span></button></li>);
    $[8] = categories;
    $[9] = onRepSelect;
    $[10] = state;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <div className="tw-absolute tw-z-10 tw-mt-1 tw-overflow-hidden tw-max-w-full tw-w-full tw-rounded-md tw-bg-iron-900 tw-shadow-2xl tw-ring-1 tw-ring-white/10"><div className="tw-py-1 tw-flow-root tw-max-h-[calc(240px+_-5vh)] tw-overflow-x-hidden tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-hover:hover:tw-scrollbar-thumb-iron-300"><ul className="tw-flex tw-flex-col tw-px-2 tw-mx-0 tw-mb-0 tw-list-none">{t1}{t2}{t3}{t4}</ul></div></div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}